var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "install-management" },
    [
      _c(
        "el-card",
        [
          _c("div", { staticClass: "top-bar" }, [
            _c(
              "div",
              { staticClass: "search-box" },
              [
                _c("el-input", {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "安装工单号", clearable: "" },
                  model: {
                    value: _vm.searchForm.installCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "installCode", $$v)
                    },
                    expression: "searchForm.installCode",
                  },
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "合同号", clearable: "" },
                  model: {
                    value: _vm.searchForm.contractNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "contractNo", $$v)
                    },
                    expression: "searchForm.contractNo",
                  },
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "120px" },
                  attrs: { placeholder: "收货人", clearable: "" },
                  model: {
                    value: _vm.searchForm.customer,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "customer", $$v)
                    },
                    expression: "searchForm.customer",
                  },
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "收货人地址", clearable: "" },
                  model: {
                    value: _vm.searchForm.customerAddress,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "customerAddress", $$v)
                    },
                    expression: "searchForm.customerAddress",
                  },
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "130px" },
                  attrs: { placeholder: "安装师傅", clearable: "" },
                  model: {
                    value: _vm.searchForm.installPerson,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "installPerson", $$v)
                    },
                    expression: "searchForm.installPerson",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "130px" },
                    attrs: { placeholder: "状态" },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "status", $$v)
                      },
                      expression: "searchForm.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "全部", value: null } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "待提交", value: 0 } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "待安装", value: 10 } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "安装中", value: 20 } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "完成", value: 40 } }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.searchLoading },
                    on: { click: _vm.handleSearch },
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.resetSearch } }, [
                  _vm._v("重置"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "config-button" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", icon: "el-icon-download" },
                    on: { click: _vm.handleExport },
                  },
                  [_vm._v("导出")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", icon: "el-icon-setting" },
                    on: { click: _vm.openConfigDialog },
                  },
                  [_vm._v("配置")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stats-cards" }, [
            _c(
              "div",
              {
                staticClass: "stats-card total",
                class: { active: _vm.activeStatus === null },
                on: {
                  click: function ($event) {
                    return _vm.handleCardClick(null)
                  },
                },
              },
              [
                _c("div", { staticClass: "stats-icon" }, [
                  _c("i", { staticClass: "el-icon-tickets" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-content" }, [
                  _c("div", { staticClass: "stats-number" }, [
                    _vm._v(_vm._s(_vm.statistics.total)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stats-label" }, [_vm._v("全部")]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "stats-card status-0",
                class: { active: _vm.activeStatus === 0 },
                on: {
                  click: function ($event) {
                    return _vm.handleCardClick(0)
                  },
                },
              },
              [
                _c("div", { staticClass: "stats-icon" }, [
                  _c("i", { staticClass: "el-icon-date" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-content" }, [
                  _c("div", { staticClass: "stats-number" }, [
                    _vm._v(_vm._s(_vm.statistics.pendingSubmit)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stats-label" }, [_vm._v("待提交")]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "stats-card status-10",
                class: { active: _vm.activeStatus === 10 },
                on: {
                  click: function ($event) {
                    return _vm.handleCardClick(10)
                  },
                },
              },
              [
                _c("div", { staticClass: "stats-icon" }, [
                  _c("i", { staticClass: "el-icon-date" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-content" }, [
                  _c("div", { staticClass: "stats-number" }, [
                    _vm._v(_vm._s(_vm.statistics.pendingInstall)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stats-label" }, [_vm._v("待安装")]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "stats-card status-20",
                class: { active: _vm.activeStatus === 20 },
                on: {
                  click: function ($event) {
                    return _vm.handleCardClick(20)
                  },
                },
              },
              [
                _c("div", { staticClass: "stats-icon" }, [
                  _c("i", { staticClass: "el-icon-setting" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-content" }, [
                  _c("div", { staticClass: "stats-number" }, [
                    _vm._v(_vm._s(_vm.statistics.installing)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stats-label" }, [_vm._v("安装中")]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "stats-card status-40",
                class: { active: _vm.activeStatus === 40 },
                on: {
                  click: function ($event) {
                    return _vm.handleCardClick(40)
                  },
                },
              },
              [
                _c("div", { staticClass: "stats-icon" }, [
                  _c("i", { staticClass: "el-icon-check" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-content" }, [
                  _c("div", { staticClass: "stats-number" }, [
                    _vm._v(_vm._s(_vm.statistics.completed)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stats-label" }, [_vm._v("完成")]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              ref: "mainTable",
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "row-key": "id",
                "max-height": _vm.tableHeight,
                "header-cell-style": {
                  backgroundColor: "#e8eaed",
                  color: "#333",
                  fontWeight: "bold",
                },
              },
              on: {
                "selection-change": _vm.handleSelectionChange,
                "row-click": _vm.handleRowClick,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.contractList &&
                        scope.row.contractList.length > 0
                          ? _c(
                              "div",
                              { staticClass: "nested-table-wrapper" },
                              [
                                _c(
                                  "el-table",
                                  {
                                    ref: "contractTable_" + scope.row.id,
                                    staticStyle: {
                                      width: "100%",
                                      "font-size": "13px",
                                    },
                                    attrs: {
                                      data: scope.row.contractList,
                                      size: "small",
                                      "header-cell-style": {
                                        backgroundColor: "#e8eaed",
                                        color: "#333",
                                        fontWeight: "bold",
                                      },
                                      border: "",
                                      "row-key": "_rowKey",
                                    },
                                    on: {
                                      "row-click": function (contractRow) {
                                        return _vm.handleContractRowClick(
                                          contractRow,
                                          "contractTable_" + scope.row.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: { type: "expand" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (contractScope) {
                                              return [
                                                contractScope.row
                                                  .designSchemes &&
                                                contractScope.row.designSchemes
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "nested-table-wrapper",
                                                        staticStyle: {
                                                          padding: "10px 30px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-table",
                                                          {
                                                            ref:
                                                              "designTable_" +
                                                              contractScope.row
                                                                ._deliveryId +
                                                              "_" +
                                                              contractScope.row
                                                                .id,
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              data: contractScope
                                                                .row
                                                                .designSchemes,
                                                              size: "mini",
                                                              "header-cell-style":
                                                                {
                                                                  backgroundColor:
                                                                    "#e8eaed",
                                                                  color: "#333",
                                                                  fontWeight:
                                                                    "bold",
                                                                },
                                                              border: "",
                                                              "row-key":
                                                                "_rowKey",
                                                            },
                                                            on: {
                                                              "row-click":
                                                                function (
                                                                  designRow
                                                                ) {
                                                                  return _vm.handleDesignRowClick(
                                                                    designRow,
                                                                    "designTable_" +
                                                                      contractScope
                                                                        .row
                                                                        ._deliveryId +
                                                                      "_" +
                                                                      contractScope
                                                                        .row.id
                                                                  )
                                                                },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  type: "expand",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          designScope
                                                                        ) {
                                                                          return [
                                                                            designScope
                                                                              .row
                                                                              .orderSolutions &&
                                                                            designScope
                                                                              .row
                                                                              .orderSolutions
                                                                              .length >
                                                                              0
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "nested-table-wrapper",
                                                                                    staticStyle:
                                                                                      {
                                                                                        padding:
                                                                                          "10px 30px",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "el-table",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            width:
                                                                                              "100%",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            data: designScope
                                                                                              .row
                                                                                              .orderSolutions,
                                                                                            size: "mini",
                                                                                            "header-cell-style":
                                                                                              {
                                                                                                backgroundColor:
                                                                                                  "#e8eaed",
                                                                                                color:
                                                                                                  "#333",
                                                                                                fontWeight:
                                                                                                  "bold",
                                                                                              },
                                                                                            border:
                                                                                              "",
                                                                                            "row-key":
                                                                                              "_rowKey",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "el-table-column",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                prop: "solutionName",
                                                                                                label:
                                                                                                  "生产分类",
                                                                                                "min-width":
                                                                                                  "120",
                                                                                                align:
                                                                                                  "center",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "el-table-column",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                prop: "packages",
                                                                                                label:
                                                                                                  "包数",
                                                                                                "min-width":
                                                                                                  "80",
                                                                                                align:
                                                                                                  "center",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "el-table-column",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                prop: "area",
                                                                                                label:
                                                                                                  "面积",
                                                                                                "min-width":
                                                                                                  "80",
                                                                                                align:
                                                                                                  "center",
                                                                                              },
                                                                                            scopedSlots:
                                                                                              _vm._u(
                                                                                                [
                                                                                                  {
                                                                                                    key: "default",
                                                                                                    fn: function (
                                                                                                      sRow
                                                                                                    ) {
                                                                                                      return [
                                                                                                        _c(
                                                                                                          "span",
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              _vm._s(
                                                                                                                sRow
                                                                                                                  .row
                                                                                                                  .area ||
                                                                                                                  0
                                                                                                              ) +
                                                                                                                " m²"
                                                                                                            ),
                                                                                                          ]
                                                                                                        ),
                                                                                                      ]
                                                                                                    },
                                                                                                  },
                                                                                                ],
                                                                                                null,
                                                                                                true
                                                                                              ),
                                                                                          }
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        "text-align":
                                                                                          "center",
                                                                                        padding:
                                                                                          "20px",
                                                                                        color:
                                                                                          "#909399",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "暂无订单方案信息"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "productionOrder",
                                                                  label:
                                                                    "销售单号",
                                                                  "min-width":
                                                                    "140",
                                                                  align:
                                                                    "center",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "总包数量",
                                                                  "min-width":
                                                                    "140",
                                                                  align:
                                                                    "center",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          dRow
                                                                        ) {
                                                                          return [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.getDesignSchemeTotalPackages(
                                                                                      dRow.row
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "text-align":
                                                            "center",
                                                          padding: "20px",
                                                          color: "#909399",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "暂无设计方案信息"
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "contractNo",
                                        label: "合同号",
                                        "min-width": "140",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.handleContractRowClick(
                                                          row.row,
                                                          "contractTable_" +
                                                            scope.row.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(row.row.contractNo)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "contactPerson",
                                        label: "客户",
                                        "min-width": "100",
                                        "show-overflow-tooltip": "",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    row.row.contactPerson || "-"
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "contactNumber",
                                        label: "收货电话",
                                        width: "130",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    row.row.contactNumber || "-"
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "contactAddress",
                                        label: "收货地址",
                                        "min-width": "180",
                                        "show-overflow-tooltip": "",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    row.row.contactAddress ||
                                                      "-"
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0 &&
                        _vm.$parent.checkPer(["admin", "install:edit"])
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#409EFF" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        _vm.$parent.checkPer(["admin", "install:edit"])
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#67C23A" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleSubmit(scope.row, 1)
                                  },
                                },
                              },
                              [_vm._v("提交")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 1 &&
                        _vm.$parent.checkPer(["admin", "install:audit"])
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#409EFF" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleSubmit(scope.row, 10)
                                  },
                                },
                              },
                              [_vm._v("审核")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 1 &&
                        _vm.$parent.checkPer(["admin", "install:cancel"])
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#F56C6C" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleSubmit(scope.row, 0)
                                  },
                                },
                              },
                              [_vm._v("取消")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        _vm.$parent.checkPer(["admin", "install:delete"])
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#909399" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm._l(_vm.tableHeader, function (col) {
                return _vm.isColumnVisible(col.key)
                  ? _c("el-table-column", {
                      key: col.key + "_" + _vm.tableRenderKey,
                      attrs: {
                        prop: col.key,
                        "min-width": _vm.getColumnWidth(col.key),
                        label: col.label,
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                col.key === "installCode"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "link-text",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleShowDetail(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.installCode))]
                                    )
                                  : col.key === "status"
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.getStatusType(
                                                scope.row.status
                                              ),
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getStatusLabel(
                                                  scope.row.status
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getColumnValue(col.key, scope.row)
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e()
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.pagination.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pagination.pageSize,
              total: _vm.pagination.total,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.configDialogVisible,
            width: "600px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.configDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                height: "300px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-right": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("可选列")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _vm._l(_vm.tableHeader, function (col) {
                        return !col.visible
                          ? _c(
                              "div",
                              {
                                key: col.key,
                                staticStyle: {
                                  padding: "8px",
                                  "margin-bottom": "8px",
                                  "background-color": "#fff",
                                  border: "1px solid #ebeef5",
                                  "border-radius": "4px",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleColumnVisible(col.key)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(col.label) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      !_vm.tableHeader.some(function (col) {
                        return !col.visible
                      })
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无可选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "center",
                    gap: "10px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-arrow-right",
                        disabled: !_vm.tableHeader.some(function (col) {
                          return !col.visible
                        }),
                      },
                      on: { click: _vm.moveAllToRight },
                    },
                    [_vm._v("全部右移")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-arrow-left",
                        disabled: !_vm.tableHeader.some(function (col) {
                          return col.visible
                        }),
                      },
                      on: { click: _vm.moveAllToLeft },
                    },
                    [_vm._v("全部左移")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-left": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _vm._v("已选列（"),
                      _c("i", {
                        staticClass: "el-icon-rank",
                        staticStyle: { "margin-right": "5px" },
                      }),
                      _vm._v("拖拽排序）"),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                      attrs: { id: "selectedColumnsList" },
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticStyle: { "min-height": "100%" },
                          attrs: {
                            options: {
                              animation: 150,
                              ghostClass: "sortable-ghost",
                              handle: ".drag-handle",
                            },
                            element: "div",
                          },
                          model: {
                            value: _vm.visibleColumns,
                            callback: function ($$v) {
                              _vm.visibleColumns = $$v
                            },
                            expression: "visibleColumns",
                          },
                        },
                        _vm._l(_vm.visibleColumns, function (col) {
                          return _c(
                            "div",
                            {
                              key: col.key,
                              staticStyle: {
                                padding: "8px",
                                "margin-bottom": "8px",
                                "background-color": "#f5f7fa",
                                "border-radius": "4px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleColumnVisible(
                                            col.key
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(col.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-rank drag-handle",
                                    staticStyle: {
                                      cursor: "move",
                                      color: "#909399",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.visibleColumns.length === 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无已选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.resetHeaderConfig } }, [
                _vm._v("重置"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveHeaderConfig },
                },
                [_vm._v("保存配置")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "安装工单详情",
            visible: _vm.detailVisible,
            width: _vm.dialogWidth,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.detailRow
            ? _c(
                "el-descriptions",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { column: 3, border: "", size: "medium" },
                },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "安装工单号" } },
                    [_vm._v(_vm._s(_vm.detailRow.installCode))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getStatusType(_vm.detailRow.status),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.getStatusLabel(_vm.detailRow.status))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                    _vm._v(_vm._s(_vm.detailRow.createTime)),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "收货人" } }, [
                    _vm._v(_vm._s(_vm.detailRow.customer || "-")),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "收货人电话" } },
                    [_vm._v(_vm._s(_vm.detailRow.customerPhone || "-"))]
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "收货地址" } }, [
                    _vm._v(_vm._s(_vm.detailRow.customerAddress || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "定位" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.detailRow.coordinateX && _vm.detailRow.coordinateY
                            ? _vm.detailRow.coordinateX +
                                ", " +
                                _vm.detailRow.coordinateY
                            : "-"
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "产品类型" } }, [
                    _vm._v(_vm._s(_vm.detailRow.productType || "-")),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "是否入住" } },
                    [
                      _vm.detailRow.isIn === true
                        ? _c(
                            "el-tag",
                            { attrs: { type: "success", size: "small" } },
                            [_vm._v("是")]
                          )
                        : _c(
                            "el-tag",
                            { attrs: { type: "info", size: "small" } },
                            [_vm._v("否")]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "安装主管" } }, [
                    _vm._v(_vm._s(_vm.detailRow.installMamager || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "安装组长" } }, [
                    _vm._v(_vm._s(_vm.detailRow.installGroup || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "安装师傅" } }, [
                    _vm._v(_vm._s(_vm.detailRow.installPerson || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "上门日期" } }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.detailRow.installDate))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "上门时间段" } },
                    [_vm._v(_vm._s(_vm.detailRow.installTime || "-"))]
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "开门方式" } }, [
                    _vm._v(_vm._s(_vm.detailRow.openWay || "-")),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "开门备注", span: 2 } },
                    [_vm._v(_vm._s(_vm.detailRow.openRemark || "-"))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "备注", span: 2 } },
                    [_vm._v(_vm._s(_vm.detailRow.remark || "-"))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.detailActiveTab,
                callback: function ($$v) {
                  _vm.detailActiveTab = $$v
                },
                expression: "detailActiveTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "操作记录", name: "log" } },
                [
                  _vm.detailActiveTab === "log"
                    ? _c("OperationRecord", {
                        attrs: {
                          "install-task-id": _vm.detailRow && _vm.detailRow.id,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "任务", name: "task" } },
                [
                  _c("TaskInfo", {
                    attrs: {
                      "task-list": _vm.detailTaskList,
                      "send-data": _vm.detailRow,
                    },
                    on: { refresh: _vm.handleTaskRefresh },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "打卡记录", name: "clockIn" } },
                [
                  _vm.detailActiveTab === "clockIn"
                    ? _c("ClockInRecord", {
                        attrs: {
                          "install-task-id": _vm.detailRow && _vm.detailRow.id,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.detailRow && _vm.detailRow.status <= 20
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleEdit(_vm.detailRow)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }